import { render } from "./CameraItem.vue?vue&type=template&id=0530dc08&scoped=true"
import script from "./CameraItem.vue?vue&type=script&lang=js"
export * from "./CameraItem.vue?vue&type=script&lang=js"

import "./CameraItem.vue?vue&type=style&index=0&id=0530dc08&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0530dc08"]])

export default __exports__